import localeTr from '@angular/common/locales/tr';
import localeEnGB from '@angular/common/locales/en-GB';
import localeEsES from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { App } from './app/app';

registerLocaleData(localeTr);
registerLocaleData(localeEnGB);
registerLocaleData(localeEsES, 'es-ES');

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: "production",
    tracesSampleRate: 0.2,
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
